/* eslint-disable eqeqeq */
import React, { Fragment, useEffect, useContext, useState, useMemo } from "react";
import { TextsContext } from '../../context/textsContext';
import { TitleH1Component } from "../../components/TitleH1Component";
import { TitleH3Component } from "../../components/TitleH3Component";
import Stylegeneral from '../../scss/general.module.scss';
import styleForm from '../../scss/form.module.scss';
import { TitleH2Component } from "../../components/TitleH2Component";
import { useCotizador } from "../../context/apiContext";
import ValidaComponent from "../../components/ValidaComponent";
import { DateSelectComponent } from "../../components/DateSelectsComponent";
import { useQuery } from "@apollo/client";
import { GET_COUNTRIES } from "graphql/queries";
import { COUNTRY_ISO_NUM, USA_CHILD_LABELS } from "constants/validationConstants";
import DialogComponent from "../../components/DialogComponent";
import { capitalizeEveryWord, isColombia } from "utils/Generics";

const Step3Pages = () => {
    const { texts, verifyCurrentLanguage, getCurrentLanguage } = useContext(TextsContext);

    const [field] = useState('zone');
    // Reactivo (no `useState`): `getCurrentLanguage()` lee `localStorage.locale`, que
    // `updateTexts` actualiza al cambiar idioma, y este componente re-renderiza cuando
    // cambia `texts`. Congelarlo en un `useState` dejaba el disclaimer de Colombia (y el
    // catálogo de países / label de USA) atados al idioma con el que se montó el step.
    const language = getCurrentLanguage();
    const [skip] = useState(0);
    const [take] = useState(300);
    const [showColombiaModal, setShowColombiaModal] = useState(false);

   
    const {
        dependantData: contextState,
        contextState: mainApplicant,
        handleOnChangeDependant: handleOnChange,
        changeDate,
        dates
    } = useCotizador();

    const { data } = useQuery(GET_COUNTRIES, {
        variables: { field, language, skip, take }
    });

    const countries = useMemo(() =>  (data?.countries ?? []).map(country => ({
                    ...country,
                    description: country.isoNum === COUNTRY_ISO_NUM.USA
                    ? USA_CHILD_LABELS[language] ?? country.description
                    : country.description
                })).sort((a, b) => a.description.localeCompare(b.description)), [data?.countries, language]);

    useEffect(() => {
        verifyCurrentLanguage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCountryChange = (e) => {
        handleOnChange(e);

        // Solo mostramos el disclaimer si el país de residencia del Step 1 es Colombia
        // y el dependiente reside en un país distinto a Colombia.
        if (isColombia(mainApplicant?.country) && !isColombia(e.target.value)) {
            setShowColombiaModal(true);
        }
    };


    return (
        <Fragment>
            <section id="sectionscroll">
                <div className="container ">
                    <div className="d-block d-lg-none">
                        <TitleH2Component styleGroup={`raleway fw_400 lh_40 color_secundary mb-0 py-2 ${Stylegeneral.titulo_principal}`}>
                            {texts?.general_header_title ?? 'My VUMI VIP Care'}
                        </TitleH2Component>
                    </div>
                    <TitleH1Component styleGroup={`raleway_semibold fw_700  lh_30 color_primary pb-3 ${Stylegeneral.titulo}`}>
                        {texts?.step3_title ?? 'Tell us about your dependents'}
                    </TitleH1Component>

                    <TitleH3Component styleGroup={`Poppins fw_400 color_primary pb-4 ${Stylegeneral.titulo}`}>
                        {texts?.step3_phrase_one ?? 'You may add your spouse/domestic partner or children. The age of the dependent cannot be over 23 years old.'}
                    </TitleH3Component>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className={`${Stylegeneral.rowForm} row gy-5 pb-5`}>
                        <div className="col-12 col-md-4">
                            <div className={`${styleForm.form_group}`}>
                                <label htmlFor="name" className={`${styleForm.labels} raleway color_primary_2`}><span className={styleForm.punto}>*</span>
                                    {texts?.general_form_field_names ?? 'Name'}
                                </label>
                                <input type="text" className={`${styleForm.input_with_line}`} placeholder={texts?.general_form_field_names ?? 'Name'} name={"name"} value={contextState.name} onChange={handleOnChange} />
                                <ValidaComponent dependant={true} keyName={"name"} />
                            </div>

                        </div>
                        <div className="col-12 col-md-4">
                            <div className={`${styleForm.form_group}`}>
                                <label htmlFor="Lastname" className={`${styleForm.labels} raleway color_primary_2`}><span className={styleForm.punto}>*</span>
                                    {texts?.general_form_field_last_names ?? 'Last name'}
                                </label>
                                <input type="text" className={`${styleForm.input_with_line}`} placeholder={texts?.general_form_field_last_names ?? 'Last name'} name={"surname"} value={contextState.surname} onChange={handleOnChange} />
                                <ValidaComponent dependant={true} keyName={"surname"} />
                            </div>

                        </div>

                        <div className="col-12 col-md-4">
                            <div className={`${styleForm.form_group}`}>
                                <div className="  d-flex align-items-center">
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1  `}>
                                        <span className={styleForm.punto}>*</span>
                                        {texts?.general_form_field_relationship ?? 'Relationship with main applicant'}
                                    </label>
                                </div>

                                <select className={`${styleForm.customselectLine}`} name={"componentId"} value={contextState.componentId} onChange={handleOnChange}>
                                    <option value="">{texts?.general_form_field_select ?? 'Select'}</option>
                                    <option value="15">{texts?.general_form_option_spouse ?? 'Spouse'}</option>
                                    <option value="16">{texts?.general_form_option_children ?? 'Son/Daugther'}</option>
                                    {/* <option value="-16">{texts?.general_form_option_other ?? 'Other'}</option> */}
                                </select>
                                <ValidaComponent dependant={true} keyName={"componentId"} />
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className={`${styleForm.form_group}`}>
                                <label htmlFor="gender" className={`${styleForm.labels} raleway mb-3 color_primary_2`}>
                                    <span className={styleForm.punto}>*</span>
                                    {texts?.general_form_field_gender ?? 'Gender'}</label>
                                <div className={`${styleForm.form_radio}`}>
                                    <div className={`${styleForm.custom_radio} pe-4`}>
                                        <label className={`me-2  ${styleForm.Control} ${contextState.gender == 1 ? styleForm.active : ""}`}
                                        >
                                            <span className={`${styleForm.title} } `}></span>
                                            <input type="radio" name={"gender"} value={1} className={styleForm.input} checked={contextState.gender == 1} onClick={handleOnChange} />
                                            <span className={styleForm.checkmark}></span>
                                        </label>
                                        <label htmlFor="femenina" className={`${styleForm.labels} raleway color_secundary raleway`}>{texts?.general_form_option_male ?? 'Male'}</label>
                                    </div>
                                    <div className={`${styleForm.custom_radio} `}>
                                        <label className={`me-2  ${styleForm.Control} ${contextState.gender == 2 ? styleForm.active : ""}`}
                                        >
                                            <span className={`${styleForm.title} } `}></span>
                                            <input type="radio" name={"gender"} className={styleForm.input} value={2} checked={contextState.gender == 2} onClick={handleOnChange} />
                                            <span className={styleForm.checkmark}></span>
                                        </label>
                                        <label htmlFor="masculino" className={`${styleForm.labels} raleway color_secundary raleway`}>{texts?.general_form_option_female ?? 'Female'}</label>
                                    </div>
                                </div>
                                <ValidaComponent dependant={true} keyName={"gender"} />

                            </div>
                        </div>
                        <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group}  ${styleForm.form_h}`}>
                                <label htmlFor="name" className={`${styleForm.labels} mb-0 raleway color_primary_2`}>
                                    <span className={styleForm.punto}>*</span>
                                    {texts?.general_form_field_birth_date ?? 'Date of birth'}</label>                             
                                <DateSelectComponent
                                    minYear={(new Date().getFullYear() - 100)}
                                    maxYear={(new Date().getFullYear())}
                                    value={dates.dependantB}
                                    onChange={(newValue) => changeDate("dependantB", newValue)}
                                />
                                <ValidaComponent dependant={true} keyName={"birthday"} />

                            </div>
                        </div>
                        <div className={`col-12 col-md-4 ${Stylegeneral.colform}`}>
                            <div className={`${styleForm.form_group} ${styleForm.form_h}`}>
                                <div className="  d-flex align-items-center">
                                    <label htmlFor="seclet" className={`${styleForm.labels} raleway  color_primary_2 pe-1  `}>
                                        <span className={styleForm.punto}>*</span>
                                        {texts?.general_form_field_country ?? 'Country of residence'}</label>

                                </div>

                                <select className={`${styleForm.customselectLine}`} name={"country"} value={contextState.country} onChange={handleCountryChange}>
                                    <option value={0} selected={true} disabled={true}>{texts?.general_form_field_select ?? 'Select'}</option>
                                    {
                                        countries
                                            ?.map(country => (
                                                <option key={country.id} value={country.isoNum}>{capitalizeEveryWord(country.description)}</option>
                                            ))
                                    }
                                </select>
                                <ValidaComponent dependant={true} keyName={"country"} />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <DialogComponent
                show={showColombiaModal}
                width="520px"
                confirmText={texts?.modal_button_accept ?? 'Accept'}
                onConfirm={() => setShowColombiaModal(false)}
            >
                <p className="text-center color_primary raleway mb-0">
                    {texts?.step3_colombia_dependent_disclaimer}
                </p>
            </DialogComponent>
        </Fragment>
    )
}
export default Step3Pages;
